import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-education-history-section',
  templateUrl: './education-history-section.component.html',
  styleUrls: ['./education-history-section.component.scss'],
  standalone: false
})
export class EducationHistorySectionComponent implements OnInit {
  private route = inject(ActivatedRoute);

  workerId: number;
  educationHistoryFormGroup: UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
    this.workerId = this.route.parent.snapshot.data.workerProfile.WorkerId;
  }
}
